export default __webpack_public_path__ + "static/media/lining16.301f4c05.jpg";